

export enum AccountingProcessActiveIndicator {
	Inactive = 0,
	Active = 1,
	Archived = 2
}